/* 新增代码 - 自定义接收邮箱表单提交 */
(function () {
  function initFormSubmission() {
    document.querySelectorAll('[data-form-submission-custom]').forEach(function (form) {
      if (form.dataset.initialized === 'true') return;
      form.dataset.initialized = 'true';

      var recipient = form.dataset.recipient;
      var fieldsWrap = form.querySelector('[data-form-submission-fields]');
      var successEl = form.querySelector('[data-form-submission-success]');
      var errorEl = form.querySelector('[data-form-submission-error]');
      var submitBtn = form.querySelector('.form-submission__submit');
      var defaultErrorText = errorEl ? errorEl.textContent : 'Submission failed. Please try again later.';

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (!recipient) {
          if (errorEl) {
            errorEl.textContent = 'Recipient email is not configured.';
            errorEl.hidden = false;
          }
          return;
        }

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        var formData = new FormData(form);
        formData.append('_subject', 'MiraBox Distribution Growth Program Application');
        formData.append('_captcha', 'false');
        formData.append('_template', 'table');

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.classList.add('form-submission__submit--loading');
        }

        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = defaultErrorText;
        }

        fetch('https://formsubmit.co/ajax/' + encodeURIComponent(recipient), {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json'
          }
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Submit failed');
            }

            if (fieldsWrap) {
              fieldsWrap.hidden = true;
            }

            if (successEl) {
              successEl.hidden = false;
              successEl.setAttribute('tabindex', '-1');
              successEl.focus();
            }
          })
          .catch(function () {
            if (errorEl) {
              errorEl.hidden = false;
            }
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.classList.remove('form-submission__submit--loading');
            }
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFormSubmission);
  } else {
    initFormSubmission();
  }

  document.addEventListener('shopify:section:load', initFormSubmission);
})();
